import React, { useState, useEffect } from "react";
import { Spinner, Card } from "react-bootstrap";
import { animateScroll as scroll } from "react-scroll";
import "./Utilities.css";
import LoadingGif from "./resource/LoadingGif.gif";
import PropTypes from "prop-types";
import ScrollToTopButton from "./resource/ScrollToTopButton.png";

export function SpinnerUtility({ align, animation }) {
    return (
        <div align={align}>
            <Spinner animation={animation} />
        </div>
    );
}

SpinnerUtility.propTypes = {
    align: PropTypes.string.isRequired,
    animation: PropTypes.string.isRequired,
};

export function LoadingPageGif({ background }) {
    return (
        <div className="loading_page_gif" style={{ backgroundColor: background }}>
            <img src={LoadingGif} alt="loading_page_gif" />
        </div>
    );
}

LoadingPageGif.propTypes = {
    background: PropTypes.string.isRequired,
};

export function CalculateAge({ dateOfBirth }) {
    let todayDate = new Date();
    let todayDay = todayDate.getDate();
    let todayMonth = todayDate.getMonth();
    let todayYear = todayDate.getFullYear();

    let birthDate = new Date(dateOfBirth);
    let birthDay = birthDate.getDate();
    let birthMonth = birthDate.getMonth();
    let birthYear = birthDate.getFullYear();

    let age = todayYear - birthYear;

    if (todayMonth > birthMonth || (todayMonth === birthMonth && todayDay >= birthDay)) return age;
    else return age - 1;
}

CalculateAge.propTypes = {
    dateOfBirth: PropTypes.string.isRequired,
};

export function ScrollToTopUtility() {
    const [is_visible, SetVisibility] = useState(false);

    useEffect(() => {
        document.addEventListener("scroll", function () {
            if (window.pageYOffset > 600) SetVisibility(true);
            else SetVisibility(false);
        });
    }, []);

    return (
        is_visible && (
            <img
                onClick={scroll.scrollToTop}
                className="scroll_to_top_button"
                src={ScrollToTopButton}
                alt="scroll_to_top_button"
            />
        )
    );
}

export function ErrorPage({ statusText, status, message }) {
    return (
        <div className="error_page">
            <div className="container">
                <h2> {statusText} </h2>
                <h1> {status} </h1>
                <span> {message} </span>
            </div>
        </div>
    );
}

export function ErrorHandler({ error }) {
    if (error.response)
        return <ErrorPage statusText={error.response.statusText} status={error.response.status} />;
    else if (error.request) return <ErrorPage message="Problem with Request" />;
    else return <ErrorPage message="Error" />;
}

ErrorHandler.propTypes = {
    error: PropTypes.object.isRequired,
};

export function CardUtility({ src, href, name, description, limit, button }) {
    return (
        <Card>
            <div className="image">
                <img src={src} className="card-img-top" alt="black" />
            </div>
            <Card.Body>
                <Card.Link href={href} target="_blank" rel="noopener">
                    <Card.Title> {name} </Card.Title>
                </Card.Link>
                <Card.Text>
                    <TrimString string={description} limit={limit} />
                </Card.Text>
            </Card.Body>
            <Card.Footer>
                <Card.Link href={href} target="_blank" rel="noopener" className="btn btn-primary">
                    {button}
                </Card.Link>
            </Card.Footer>
        </Card>
    );
}

export function TrimString({ string, limit }) {
    return string != null
        ? string.length <= limit
            ? string
            : string.substring(0, limit) + "..."
        : "";
}

TrimString.propTypes = {
    string: PropTypes.string.isRequired,
    limit: PropTypes.number.isRequired,
};
